import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css'
// import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

const opts = {
  // theme: {
  //   themes: {
  //     light: {
  //       primary: "#F0C316",
  //       secondary: colors.grey.darken1,
  //       accent: colors.shades.black,
  //       error: colors.red.accent3,
  //     },
  //     dark: {
  //       primary: colors.blue.lighten3,
  //     },
  //   },
  // },
}

export default new Vuetify(opts)